import { Timestamp } from "firebase/firestore";
import moment, { Moment } from "moment";
import serializable, { propretyCustomSerializable } from "../common/decorators/serializable";
import { EntityFirebase } from "../common/entity.firebase";

export type CreditTransactionType = "debt" | "payment";

@serializable
export class CreditTransaction extends EntityFirebase {
  @propretyCustomSerializable((value: Moment) => Timestamp.fromDate(value.toDate()))
  private createdAt: Moment;

  constructor(
    public readonly id: string,
    private customerId: string,
    private saleId: string | null,
    private type: CreditTransactionType,
    private amount: number,
    private description: string,
    createdAt: Moment = moment()
  ) {
    super();
    this.createdAt = createdAt;
  }

  getCustomerId() {
    return this.customerId;
  }

  getSaleId() {
    return this.saleId;
  }

  getType() {
    return this.type;
  }

  getAmount() {
    return this.amount;
  }

  getDescription() {
    return this.description;
  }

  getCreatedAt() {
    return this.createdAt;
  }

  static async build(id: string, data: any) {
    return new this(
      id,
      data.customerId || "",
      typeof data.saleId === "string" ? data.saleId : null,
      data.type === "payment" ? "payment" : "debt",
      typeof data.amount === "number" ? data.amount : 0,
      data.description || "",
      data.createdAt ? moment(data.createdAt.toDate()) : moment()
    );
  }
}
